const state = {
  helpContent: {},
};
const getters = {
  helpContent: (state) => {
    return state.helpContent;
  },
};
const actions = {
  setHelpContent({ commit, rootGetters }, routeName) {
    // Use product name from appConfig in app Vuex module to point to correct help filename for this application
    const helpFile = require(`@/assets/data/${rootGetters['app/appConfig'].product.name}-help.json`);
    const activeDataSource = rootGetters['app/activeDataSource'];

    // Get global help content available to all routes
    const globalHelpContent = helpFile.global;
    // Get help content for the active data source / route
    const routeHelpContent = activeDataSource
      ? helpFile[activeDataSource][routeName]
      : helpFile[routeName];

    if (routeHelpContent) {
      // Add global tooltips to route tooltips
      routeHelpContent.tooltips = routeHelpContent.tooltips
        ? { ...globalHelpContent.tooltips, ...routeHelpContent.tooltips }
        : { ...globalHelpContent.tooltips };
      // Update helpContent state
      commit('setHelpContent', routeHelpContent);
    } else {
      // Set help content to only contain global help content if no route help content is available
      commit('setHelpContent', globalHelpContent);
    }
  },
};
const mutations = {
  setHelpContent(state, payload) {
    state.helpContent = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
